function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "230px",
    height: "80px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.903
    },
    fill: "#227dc2",
    d: "M 9.5,3.5 C 30.1667,3.5 50.8333,3.5 71.5,3.5C 71.5,6.5 71.5,9.5 71.5,12.5C 50.8333,12.5 30.1667,12.5 9.5,12.5C 9.5,9.5 9.5,6.5 9.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef3e32",
    d: "M 148.5,12.5 C 146.302,12.5912 145.969,11.9245 147.5,10.5C 155.414,9.53281 163.414,9.19947 171.5,9.5C 171.5,10.5 171.5,11.5 171.5,12.5C 163.833,12.5 156.167,12.5 148.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f04a3b",
    d: "M 147.5,10.5 C 145.969,11.9245 146.302,12.5912 148.5,12.5C 146.832,14.4786 146.166,16.812 146.5,19.5C 145.883,19.6107 145.383,19.944 145,20.5C 144.804,18.7139 143.971,17.3805 142.5,16.5C 141.52,19.0865 141.187,21.7531 141.5,24.5C 138.766,17.8515 140.766,13.1848 147.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee2e29",
    d: "M 146.5,19.5 C 148.5,21.1667 150.5,22.8333 152.5,24.5C 152.98,28.3951 150.98,30.7284 146.5,31.5C 144.453,29.4504 142.786,27.117 141.5,24.5C 141.187,21.7531 141.52,19.0865 142.5,16.5C 143.971,17.3805 144.804,18.7139 145,20.5C 145.383,19.944 145.883,19.6107 146.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#227dc2",
    d: "M 9.5,17.5 C 43.5,17.5 77.5,17.5 111.5,17.5C 111.5,20.5 111.5,23.5 111.5,26.5C 77.5,26.5 43.5,26.5 9.5,26.5C 9.5,23.5 9.5,20.5 9.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.893
    },
    fill: "#ec2024",
    d: "M 115.5,43.5 C 114.167,42.1667 114.167,40.8333 115.5,39.5C 116.687,37.0246 118.687,36.0246 121.5,36.5C 121.5,33.1667 121.5,29.8333 121.5,26.5C 124.5,26.5 127.5,26.5 130.5,26.5C 130.5,29.8333 130.5,33.1667 130.5,36.5C 131.5,36.5 132.5,36.5 133.5,36.5C 133.5,38.1667 133.5,39.8333 133.5,41.5C 132.5,41.5 131.5,41.5 130.5,41.5C 130.5,49.1667 130.5,56.8333 130.5,64.5C 127.5,64.5 124.5,64.5 121.5,64.5C 121.5,56.8333 121.5,49.1667 121.5,41.5C 119.315,41.7036 117.315,42.3702 115.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.811
    },
    fill: "#ec1f23",
    d: "M 157.5,26.5 C 160.777,26.2161 163.943,26.5495 167,27.5C 167.5,39.8288 167.667,52.1622 167.5,64.5C 164.167,64.5 160.833,64.5 157.5,64.5C 157.5,51.8333 157.5,39.1667 157.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.891
    },
    fill: "#ed2325",
    d: "M 184.5,56.5 C 185.924,54.4855 186.59,52.1522 186.5,49.5C 188.167,48.5 189.5,47.1667 190.5,45.5C 193.518,45.3354 196.518,45.502 199.5,46C 198.263,46.2321 197.263,46.7321 196.5,47.5C 195.531,48.3094 194.698,49.3094 194,50.5C 193.502,53.8168 193.335,57.1501 193.5,60.5C 197.833,60.5 202.167,60.5 206.5,60.5C 206.5,61.8333 206.5,63.1667 206.5,64.5C 194.5,64.5 182.5,64.5 170.5,64.5C 170.5,51.8333 170.5,39.1667 170.5,26.5C 173.5,26.5 176.5,26.5 179.5,26.5C 179.5,37.8333 179.5,49.1667 179.5,60.5C 181.167,60.5 182.833,60.5 184.5,60.5C 184.5,59.1667 184.5,57.8333 184.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f14e3d",
    d: "M 152.5,24.5 C 153.812,25.1451 154.812,26.1451 155.5,27.5C 153.476,29.6898 151.643,32.0232 150,34.5C 148.855,33.3636 147.688,32.3636 146.5,31.5C 150.98,30.7284 152.98,28.3951 152.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#317cbc",
    d: "M 77.5,30.5 C 84.7028,30.8632 87.5361,34.5299 86,41.5C 81.5706,46.8084 77.2373,46.8084 73,41.5C 71.3926,36.4383 72.8926,32.7716 77.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.849
    },
    fill: "#2b7cbe",
    d: "M 28.5,48.5 C 27.5084,48.6716 26.8417,48.3382 26.5,47.5C 26.2488,45.8297 25.5822,44.3297 24.5,43C 19.5111,42.5007 14.5111,42.3341 9.5,42.5C 9.5,39.1667 9.5,35.8333 9.5,32.5C 17.6249,30.8154 24.1249,33.1488 29,39.5C 29.8045,42.6965 29.6378,45.6965 28.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.783
    },
    fill: "#ee2d29",
    d: "M 145.5,60.5 C 145.842,59.6618 146.508,59.3284 147.5,59.5C 148.117,59.6107 148.617,59.944 149,60.5C 149.499,55.1771 149.666,49.8437 149.5,44.5C 146.813,44.3359 144.146,44.5026 141.5,45C 140.309,45.6979 139.309,46.5313 138.5,47.5C 137.833,48.5 137.167,49.5 136.5,50.5C 136.5,47.5 136.5,44.5 136.5,41.5C 137.673,39.4959 139.34,37.9959 141.5,37C 145.44,35.9847 149.44,35.4847 153.5,35.5C 153.5,45.1667 153.5,54.8333 153.5,64.5C 146.833,64.5 140.167,64.5 133.5,64.5C 133.5,63.5 133.5,62.5 133.5,61.5C 137.702,61.8168 141.702,61.4834 145.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.814
    },
    fill: "#277cc0",
    d: "M 62.5,62.5 C 61.6328,60.0414 61.2995,57.7081 61.5,55.5C 61.6657,51.1539 61.499,46.8206 61,42.5C 58.6954,44.9305 55.8621,45.9305 52.5,45.5C 52.5,44.8333 52.1667,44.5 51.5,44.5C 51.1667,43.5 50.5,42.8333 49.5,42.5C 49.1667,42.5 48.8333,42.5 48.5,42.5C 46.2014,36.0978 48.3681,32.0978 55,30.5C 60.2396,31.7759 62.7396,35.1093 62.5,40.5C 65.5,40.5 68.5,40.5 71.5,40.5C 71.5,47.8333 71.5,55.1667 71.5,62.5C 68.5,62.5 65.5,62.5 62.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#337bba",
    d: "M 48.5,42.5 C 48.5,43.1667 48.8333,43.5 49.5,43.5C 50.6602,45.2027 49.9935,45.8693 47.5,45.5C 46.7197,50.7206 44.3863,55.2206 40.5,59C 37.634,60.4568 34.634,60.7901 31.5,60C 28.7663,59.2817 28.0996,57.7817 29.5,55.5C 34.3514,57.1768 37.0181,55.3434 37.5,50C 37.7022,47.2464 37.3688,44.413 36.5,41.5C 40.6002,41.2367 44.6002,41.5701 48.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#ed2425",
    d: "M 214.5,63.5 C 215.562,61.7659 215.562,60.0992 214.5,58.5C 214.666,53.8215 214.499,49.1548 214,44.5C 211.859,47.3208 209.025,48.6541 205.5,48.5C 205.5,47.8333 205.167,47.5 204.5,47.5C 203.833,46.1667 202.833,45.1667 201.5,44.5C 201.167,44.5 200.833,44.5 200.5,44.5C 199.197,38.4772 201.53,34.8105 207.5,33.5C 212.983,34.6469 215.316,37.9802 214.5,43.5C 217.5,43.5 220.5,43.5 223.5,43.5C 223.5,50.5 223.5,57.5 223.5,64.5C 220.287,64.81 217.287,64.4767 214.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#4a79ae",
    d: "M 49.5,42.5 C 50.5,42.8333 51.1667,43.5 51.5,44.5C 52.1667,44.5 52.5,44.8333 52.5,45.5C 55.0413,49.2518 58.0413,52.5852 61.5,55.5C 61.2995,57.7081 61.6328,60.0414 62.5,62.5C 57.2745,57.0618 52.2745,51.3951 47.5,45.5C 49.9935,45.8693 50.6602,45.2027 49.5,43.5C 49.5,43.1667 49.5,42.8333 49.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#f15848",
    d: "M 136.5,41.5 C 136.5,44.5 136.5,47.5 136.5,50.5C 134.12,47.4468 134.12,44.4468 136.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.702
    },
    fill: "#f3614d",
    d: "M 190.5,45.5 C 189.5,47.1667 188.167,48.5 186.5,49.5C 186.833,47.1667 188.167,45.8333 190.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#f04637",
    d: "M 200.5,44.5 C 200.5,45.1667 200.833,45.5 201.5,45.5C 202.167,46.8333 203.167,47.8333 204.5,48.5C 204.833,48.5 205.167,48.5 205.5,48.5C 208.529,51.859 211.529,55.1924 214.5,58.5C 215.562,60.0992 215.562,61.7659 214.5,63.5C 210.032,58.8613 205.699,54.028 201.5,49C 199.975,47.9914 198.308,47.4914 196.5,47.5C 197.263,46.7321 198.263,46.2321 199.5,46C 196.518,45.502 193.518,45.3354 190.5,45.5C 191.624,44.1914 193.124,43.5247 195,43.5C 196.825,43.9434 198.658,44.2767 200.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.153
    },
    fill: "#f47e61",
    d: "M 201.5,44.5 C 202.833,45.1667 203.833,46.1667 204.5,47.5C 204.5,47.8333 204.5,48.1667 204.5,48.5C 203.167,47.8333 202.167,46.8333 201.5,45.5C 201.5,45.1667 201.5,44.8333 201.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dd392e",
    d: "M 115.5,39.5 C 114.167,40.8333 114.167,42.1667 115.5,43.5C 109.5,48.8333 103.833,54.5 98.5,60.5C 98.6495,59.448 98.4828,58.448 98,57.5C 97.2917,58.3805 96.4584,59.0472 95.5,59.5C 101.167,51.8333 107.833,45.1667 115.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#f14d3c",
    d: "M 138.5,47.5 C 138.351,48.552 138.517,49.552 139,50.5C 142.038,53.3694 144.871,56.3694 147.5,59.5C 146.508,59.3284 145.842,59.6618 145.5,60.5C 141.105,58.4378 138.105,55.1045 136.5,50.5C 137.167,49.5 137.833,48.5 138.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.498
    },
    fill: "#f2614d",
    d: "M 186.5,49.5 C 186.59,52.1522 185.924,54.4855 184.5,56.5C 184.41,53.8478 185.076,51.5145 186.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#4579b0",
    d: "M 26.5,47.5 C 26.8417,48.3382 27.5084,48.6716 28.5,48.5C 24.8548,55.4785 19.5215,60.8118 12.5,64.5C 11.791,63.596 10.791,63.2627 9.5,63.5C 15.823,58.8431 21.4896,53.5098 26.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.298
    },
    fill: "#d14636",
    d: "M 98.5,60.5 C 98.4326,61.9587 98.7659,63.2921 99.5,64.5C 98.4138,64.38 97.7472,63.7133 97.5,62.5C 97.5427,61.5836 97.8761,60.9169 98.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3a7bb8",
    d: "M 81.5,50.5 C 82.675,50.281 83.675,50.6143 84.5,51.5C 93.719,68.2943 88.719,75.961 69.5,74.5C 69.5079,71.4552 69.8413,68.4552 70.5,65.5C 73.3743,65.4511 76.2077,65.7844 79,66.5C 81.4059,66.2971 83.4059,65.2971 85,63.5C 84.4618,59.0626 83.2952,54.7292 81.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9
    },
    fill: "#ec2124",
    d: "M 98.5,60.5 C 97.8761,60.9169 97.5427,61.5836 97.5,62.5C 97.7472,63.7133 98.4138,64.38 99.5,64.5C 118.424,65.4867 137.424,65.82 156.5,65.5C 156.5,68.5 156.5,71.5 156.5,74.5C 137.164,74.6666 117.83,74.5 98.5,74C 97.3333,72.8333 96.1667,71.6667 95,70.5C 94.1901,66.6425 94.3567,62.9758 95.5,59.5C 96.4584,59.0472 97.2917,58.3805 98,57.5C 98.4828,58.448 98.6495,59.448 98.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.897
    },
    fill: "#227cc1",
    d: "M 9.5,63.5 C 10.791,63.2627 11.791,63.596 12.5,64.5C 28.9916,65.4965 45.6583,65.8298 62.5,65.5C 62.5,68.5 62.5,71.5 62.5,74.5C 44.8333,74.5 27.1667,74.5 9.5,74.5C 9.5,70.8333 9.5,67.1667 9.5,63.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.5d5882e3a99762ac9ae3bd8f6b9f04f1.svg";
export { ForwardRef as ReactComponent };